<template>
    <div v-if="cargando">Cargando</div>
    <div v-else>
        <p class="md-headline">Color</p>
        <div v-if="version.elements5.length">
            <p class="text-capitalize">{{minusculas(formulario.color.dt1)}}</p>
            <div class="row justify-content-center">
                <boton-color
                        v-for="item in version.elements5"
                        :key="item.id"
                        :datos="item"
                        v-model="formulario.color"
                        :valor="formulario.color"
                />
            </div>
        </div>
        <div v-else>
            <div class="alert alert-secondary" role="alert">
                <div class="alert-text">Por el momento no contamos con colores disponibles para este modelo.</div>
            </div>
        </div>
        <div class="pt-5 d-flex justify-content-between align-text-bottom abajo">
            <button type="button" class="btn btn-secondary btn-font-sm" v-on:click="atras"><i class="flaticon2-back"></i> Regresar</button>
            <button type="button" class="btn btn-primary btn-font-sm" v-on:click="siguiente"> Continuar <i class="flaticon2-next"></i></button>
        </div>
    </div>
</template>

<script>
    import BotonColor from "../../../componentes/boton-color";
    import constantes from "../../../constantes";
    export default {
        name: "exterior",
        data:()=>({
            formulario:{
                color:{id:null,}
            }
        }),
        props:["cargando","version","numAc"],
        components: {
            BotonColor
        },
        watch:{
            "formulario.color.id":function(){
                this.$emit('input',this.formulario.color);
            }
        },
        methods:{
            minusculas:(texto)=>constantes.funciones.minusculas(texto),
            atras:function(){
                this.$store.commit('setSubActual',this.numAc ? 3 : 2);
            },
            siguiente:function(){
                this.$store.commit('setActual',3);
                this.$store.commit('setSubActual',1);
                this.$router.push({ name: 'p3', params: { titulo:  this.$route.params.titulo ,id:this.$route.params.id} });
            },
        },
        created() {
            if(this.$store.getters.getPasos["2"].color.id){
              this.formulario.color=this.$store.getters.getPasos["2"].color;
            }else{
              if(this.version.elements5){
                this.formulario.color=this.version.elements5[0]
              }
            }
        }
    }
</script>
